"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Tracks visibility of child elements and returns a flag indicating whether children
 * are in the browser's viewport.
 */
var ViewportChecker = function ViewportChecker(_ref) {
  var children = _ref.children,
    _ref$onIntersection = _ref.onIntersection,
    onIntersection = _ref$onIntersection === void 0 ? function () {} : _ref$onIntersection,
    percentVisible = _ref.percentVisible,
    _ref$unobserveOnInter = _ref.unobserveOnIntersection,
    unobserveOnIntersection = _ref$unobserveOnInter === void 0 ? false : _ref$unobserveOnInter,
    _ref$yThreshold = _ref.yThreshold,
    yThreshold = _ref$yThreshold === void 0 ? 0 : _ref$yThreshold,
    _ref$xThreshold = _ref.xThreshold,
    xThreshold = _ref$xThreshold === void 0 ? 0 : _ref$xThreshold;
  var elementRef = (0, _react.useRef)(null);
  var observerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersecting = _useState2[0],
    setIsIntersecting = _useState2[1];
  var callback = function callback(browserBuiltInEventEntries) {
    // since ViewportChecker only permits tracking a single element,
    // we always want the first (and what should be the only) element in the array of
    // intersection event entries the browser gives us.
    // More about the entry properties: https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry
    var entry = browserBuiltInEventEntries === null || browserBuiltInEventEntries === void 0 ? void 0 : browserBuiltInEventEntries[0];
    if (!entry.isIntersecting) {
      return setIsIntersecting(false);
    }
    onIntersection();
    if (unobserveOnIntersection && elementRef.current !== null) {
      observerRef.current.unobserve(elementRef.current);
    }
    setIsIntersecting(true);
  };
  var threshold = 0;
  if (percentVisible && percentVisible > 0 && percentVisible <= 100) {
    threshold = percentVisible / 100;
  }
  (0, _react.useEffect)(function () {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.IntersectionObserver) {
      observerRef.current = new window.IntersectionObserver(callback, {
        rootMargin: "".concat(yThreshold, "px ").concat(xThreshold, "px"),
        threshold: threshold
      });
      if (elementRef.current !== null) {
        observerRef.current.observe(elementRef.current);
      }
    }
    return function () {
      var _observerRef$current, _observerRef$current$;
      (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || (_observerRef$current$ = _observerRef$current.disconnect) === null || _observerRef$current$ === void 0 || _observerRef$current$.call(_observerRef$current);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children({
    isIntersecting: isIntersecting,
    unobserve: function unobserve() {
      if (elementRef.current !== null) {
        observerRef.current.unobserve(elementRef.current);
      }
    },
    elementRef: elementRef
  }));
};
ViewportChecker.displayName = 'ViewportChecker';
ViewportChecker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Child function with boolean parameter: `isIntersecting`, function
   * `unobserve` that can be called when wanting to stop observing the element,
   * and `elementRef` that needs to be passed in to the element that is being observed
   */
  children: _propTypes["default"].func.isRequired,
  /**
   * Called when element becomes visible, useful for integrating with external
   * libraries and for triggering events.
   */
  onIntersection: _propTypes["default"].func,
  /**
   * Percent of the element that is visible threshold for triggering
   * `onIntersection`. For example, a value of 50 will trigger
   * `onIntersection` if the element is 50% visibile.  Only values between
   * 0 and 100 (inclusive of 100) are valid.
   */
  percentVisible: _propTypes["default"].number,
  /**
   * Prop to have the ViewportChecker automatically unobserve after the first
   * intersection.  By default, the ViewportChecker will keep checking if the
   * element is in the viewport or not after the first time.
   */
  unobserveOnIntersection: _propTypes["default"].bool,
  /**
   * Pixel value threshold for triggering `onIntersection` on x-axis.
   * For example, a value of 600 will trigger `onIntersection` if
   * the element comes within 600px of the viewport edge on the x-axis.
   */
  xThreshold: _propTypes["default"].number,
  /**
   * Pixel value threshold for triggering `onIntersection` on y-axis.
   * For example, a value of 600 will trigger `onIntersection` if
   * the element comes within 600px of the viewport edge on the y-axis.
   */
  yThreshold: _propTypes["default"].number
} : {};
var _default = exports["default"] = ViewportChecker;